
import RecordDetails from "../recordDetails/recordDetails";
import RelatedInfo from "../relatedInfo/relatedInfo";
import React, { useEffect, useState } from "react";
import { AccessLevel, RowLevelAction } from "../../types/types";
import { Tabs } from "antd";
import { refreshDataTable } from "../../components/recordDetails/recordDetailUtils";
import { GetRequest } from "../../utils/api";
import { useTranslation } from "react-i18next";
import CustomLoader from "../loader";

export interface ViewSingleBlueprintFormProps {
  urlparams: Map<string, string>;
  open: boolean;
  platformAction: RowLevelAction;
  setOpen: (value: boolean) => void;
  blueprintApi: string;
  title: string;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  isNewRelatedInfo?: boolean;
  userAccessLevel: AccessLevel;
  recordIds?: any[];
  loanNos?: any[];
  customerNames?: any[];
  refreshTable: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  moduleCode: string;
  renderCustomDetailPage?: Function;
  enableStepNext?: boolean;
  enableStepSubmit?: boolean;
  enableStepBack?: boolean;
  onStepAction?: Function;
  allowedActionsForRenderingCustomDetailPage?: string[];
  extraActionsOnRecordCallback?: Function;
  dataApi?: string
}

const ViewSingleBlueprintForm: React.FC<ViewSingleBlueprintFormProps> = ({
  title,
  urlparams,
  open,
  setOpen,
  blueprintApi,
  isCreateFlow,
  isRelatedInfo,
  userAccessLevel,
  platformAction,
  recordIds,
  loanNos,
  customerNames,
  refreshTable,
  allowEdits,
  selectedRows,
  moduleCode,
  renderCustomDetailPage,
  enableStepNext,
  enableStepSubmit,
  enableStepBack,
  onStepAction,
  allowedActionsForRenderingCustomDetailPage,
  extraActionsOnRecordCallback,
  dataApi

}) => {



  const [viewPageBluPrint, setViewPageBluPrint] = useState<any>({});
  const [currentBluePrintApi, setCurrentBluePrintApi] = useState<string>("");
  const { t } = useTranslation();

  const TabKeys = {
    DETAIL: "detail",
    RELATED: "related",
    NEWINFO: "newinfo",
  };

  const getItems = (): any[] => {
    const items = [
      {
        label: t(`${title} Details `),
        key: TabKeys.DETAIL,
        //users/blueprint/usersEditForm
        children: childTabs(),
      },
    ];

    if (isRelatedInfo) {
      items.push({
        label: t("Related Info"),
        key: TabKeys.RELATED,
        children: (
          <RelatedInfo
            urlparams={urlparams}
            bluprintSections={viewPageBluPrint ? viewPageBluPrint.related : []}
            viewHideEmptyFields={viewPageBluPrint?.viewHideEmptyFields}
            sectionsBlueprintApis={viewPageBluPrint ? viewPageBluPrint.relatedInfoBlueprintApi : []}
            showSearch={viewPageBluPrint.relatedInfoShowSearch ?? false}
          />
        ),
      });

    }

    if (viewPageBluPrint?.newInfo) {
      items.push({
        label: t("New Info"),
        key: TabKeys.NEWINFO,
        children: (
          <RelatedInfo
            urlparams={urlparams}
            bluprintSections={viewPageBluPrint ? viewPageBluPrint?.newInfo : []}
            viewHideEmptyFields={viewPageBluPrint?.viewHideEmptyFields}
            sectionsBlueprintApis={[]}
            showSearch={viewPageBluPrint.relatedInfoShowSearch ?? false}
          />
        ),
      });
    }

    return items;
  };

  useEffect(() => {
    getBlueprintData();
  }, [blueprintApi]);

  // this doesnt need to take a redux route as its redundant to store in global state.
  const getBlueprintData = async () => {
    if (blueprintApi?.length > 0) {

      let response = await GetRequest(blueprintApi);
      setViewPageBluPrint(response);
      setCurrentBluePrintApi(blueprintApi);

    }
  };

  // const viewData = useRef();

  // const setViewData = (data:any) => {
  //   viewData.current = data;
  // }

  const childTabs = () => {

    return (
      <>
        {viewPageBluPrint?.detailSections ? (
          <RelatedInfo
            urlparams={urlparams}
            bluprintSections={viewPageBluPrint.detailSections ?? []}
            sectionsBlueprintApis={viewPageBluPrint ? viewPageBluPrint.relatedInfoBlueprintApi : []}
            viewHideEmptyFields={viewPageBluPrint?.viewHideEmptyFields}
            showSearch={viewPageBluPrint.relatedInfoShowSearch ?? false}
          ></RelatedInfo>
        ) : (
          <></>
        )}

        {renderCustomDetailPage &&
          allowedActionsForRenderingCustomDetailPage?.findIndex((action) => action.toLowerCase() === platformAction.toLowerCase()) !== -1 ? (
          renderCustomDetailPage({
            title,
            viewPageBluPrint,
            urlparams,
            open,
            setOpen,
            blueprintApi,
            isCreateFlow,
            isRelatedInfo,
            userAccessLevel,
            platformAction,
            recordIds,
            loanNos,
            customerNames,
            refreshTable,
            allowEdits,
            selectedRows,
            moduleCode,
            enableStepNext,
            enableStepSubmit,
            enableStepBack,
            onStepAction,
          })
        ) : (
          <RecordDetails
            isCreateFlow={isCreateFlow}
            isRelatedInfo={isRelatedInfo}
            editForm={viewPageBluPrint ? viewPageBluPrint.editForm : []}
            dependantFields={
              viewPageBluPrint?.dependency ? viewPageBluPrint.dependency : []
            }
            viewPageBluPrint={viewPageBluPrint}
            dataApi={dataApi ?? (viewPageBluPrint ? viewPageBluPrint.dataApi : "")}
            dataApiMapper={
              viewPageBluPrint ? viewPageBluPrint.dataApiMapper : []
            }
            dataApis={viewPageBluPrint ? viewPageBluPrint.dataApis : ""}
            createApiMapper={
              viewPageBluPrint ? viewPageBluPrint.createApiMapper : []
            }
            viewApi={viewPageBluPrint ? viewPageBluPrint.viewApi : ""}
            createApi={viewPageBluPrint ? viewPageBluPrint.createApi : ""}
            updateApi={viewPageBluPrint ? viewPageBluPrint.updateApi : ""}
            recordId={urlparams.get("recordId") ?? ""}
            urlparams={urlparams}
            setOpen={setOpen}
            userAccessLevel={userAccessLevel}
            platformAction={platformAction}
            parentEntity={viewPageBluPrint ? viewPageBluPrint.parentEntity : ""}
            recordIds={recordIds}
            loanNos={loanNos}
            customerNames={customerNames}
            refreshTable={() => refreshDataTable(viewPageBluPrint?.refreshOnSave, refreshTable)}
            allowEdits={allowEdits ?? true}
            selectedRows={selectedRows}
            moduleCode={moduleCode}
            mulitiDependency={viewPageBluPrint?.mulitiDependency}
            title={title}
            extraActionsOnRecord={viewPageBluPrint?.extraActionsOnRecord}
            platformActionLabels={viewPageBluPrint?.platformActionLabels}
            hideActions={viewPageBluPrint?.hideActions}
            enableStepNext={enableStepNext}
            enableStepSubmit={enableStepSubmit}
            enableStepBack={enableStepBack}
            onStepAction={onStepAction}
            extraActionsOnRecordCallback={extraActionsOnRecordCallback}
          />
        )}
      </>
    );
  };

  return (
    <>
      {currentBluePrintApi !== blueprintApi ? (
        <div className="panel-loading">
          <CustomLoader></CustomLoader>
        </div>
      ) : (
        <Tabs
          className=""
          items={
            viewPageBluPrint?.hasOwnProperty("related")
              ? getItems()
              : getItems().slice(0, 1)
          }
        />
      )}
    </>
  );
};

export default React.memo(ViewSingleBlueprintForm);
